import React from 'react';

const AboutIntro = () => {
  return (
    <section className="py-20 px-6 max-w-7xl mx-auto">
      {/* Intro Text */}
      <div className="text-center max-w-3xl mx-auto mb-20">
        <p className="text-xl text-gray-300 leading-relaxed">
          <strong className="text-white">ANESDEV</strong> is your trusted technology partner. Since 2022, we have been helping businesses thrive in a constantly evolving digital world.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        
        {/* Our Vision Card */}
        <div className="bg-[#1A1F29]/50 backdrop-blur-md border border-white/5 rounded-2xl p-8 md:p-10 hover:border-electric-green/30 transition-colors">
          <h2 className="text-3xl font-bold text-white mb-6">Our Vision</h2>
          <p className="text-gray-400 mb-6">
            We aspire to be the leading technology partner, supporting both local and international businesses toward digital excellence.
          </p>
          <ul className="space-y-6">
            <li className="flex gap-4">
              <div className="w-2 h-2 mt-2 rounded-full bg-electric-green flex-shrink-0 shadow-[0_0_8px_rgba(57,255,20,0.8)]"></div>
              <div>
                <strong className="text-white block mb-1">Continuous Innovation:</strong>
                <span className="text-sm text-gray-400">We integrate the latest technologies to deliver cutting-edge and competitive solutions.</span>
              </div>
            </li>
            <li className="flex gap-4">
              <div className="w-2 h-2 mt-2 rounded-full bg-electric-green flex-shrink-0 shadow-[0_0_8px_rgba(57,255,20,0.8)]"></div>
              <div>
                <strong className="text-white block mb-1">Global Impact:</strong>
                <span className="text-sm text-gray-400">Helping businesses grow, optimize processes, and stay secure in an ever-evolving digital world.</span>
              </div>
            </li>
            <li className="flex gap-4">
              <div className="w-2 h-2 mt-2 rounded-full bg-electric-green flex-shrink-0 shadow-[0_0_8px_rgba(57,255,20,0.8)]"></div>
              <div>
                <strong className="text-white block mb-1">Operational Excellence:</strong>
                <span className="text-sm text-gray-400">Providing reliable, fast, and efficient IT services that exceed client expectations.</span>
              </div>
            </li>
          </ul>
        </div>

        {/* Our Mission Card */}
        <div className="bg-[#1A1F29]/50 backdrop-blur-md border border-white/5 rounded-2xl p-8 md:p-10 hover:border-electric-green/30 transition-colors">
          <span className="text-electric-green font-bold text-sm uppercase tracking-widest mb-2 block">About Us</span>
          <h2 className="text-3xl font-bold text-white mb-6">Our Mission</h2>
          <p className="text-gray-400 mb-6">
            At ANESDEV, our mission is clear: to provide effective, secure, and customized IT solutions that guide every business through its digital transformation.
          </p>
          <ul className="space-y-6">
            <li className="flex gap-4">
              <div className="w-2 h-2 mt-2 rounded-full bg-electric-green flex-shrink-0 shadow-[0_0_8px_rgba(57,255,20,0.8)]"></div>
              <div>
                <strong className="text-white block mb-1">High-Performing Solutions:</strong>
                <span className="text-sm text-gray-400">We design robust IT systems that meet our clients' real needs.</span>
              </div>
            </li>
            <li className="flex gap-4">
              <div className="w-2 h-2 mt-2 rounded-full bg-electric-green flex-shrink-0 shadow-[0_0_8px_rgba(57,255,20,0.8)]"></div>
              <div>
                <strong className="text-white block mb-1">Security First:</strong>
                <span className="text-sm text-gray-400">Protecting your data and infrastructure is our top priority.</span>
              </div>
            </li>
            <li className="flex gap-4">
              <div className="w-2 h-2 mt-2 rounded-full bg-electric-green flex-shrink-0 shadow-[0_0_8px_rgba(57,255,20,0.8)]"></div>
              <div>
                <strong className="text-white block mb-1">Tailored Support:</strong>
                <span className="text-sm text-gray-400">We analyze your unique challenges and provide customized solutions.</span>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </section>
  );
};

export default AboutIntro;